export default __webpack_public_path__ + "static/media/RossBassett.a27f918f.png";